import Vue from "/node_modules/vue/dist/vue";

export function vueCalculator() {
  Vue.config.productionTip = false;
  Vue.config.devtools = false;

  Vue.filter("formatNumber", function (value) {
    if (!value) return "0";
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  });

  var wrapperElement = document.querySelector(".wrapper");

  if (wrapperElement) {
    var app = new Vue({
      el: wrapperElement,
      data: {
        initialTicketPrice: "5",
        initialTicketPrice2: "5",
        initialTickets: "100",
        initialTickets2: "100",
        ticketPrice: "5",
        ticketPrice2: "5",
        tickets: "100",
        tickets2: "100",
      },
      methods: {
        process(value) {
          return Number(value);
        },
        resetValues() {
          this.ticketPrice = this.initialTicketPrice;
          this.ticketPrice2 = this.initialTicketPrice2;
          this.tickets = this.initialTickets;
          this.tickets2 = this.initialTickets2;

          const ticketPriceRange =
            document.getElementById("ticket-price-range");
          if (ticketPriceRange) {
            this.updateSliderFill();
          }

          const numberOfTicketsRange = document.getElementById(
            "number-of-tickets-range"
          );
          if (numberOfTicketsRange) {
            this.updateTicketsSliderFill();
          }
        },
        updateSliderFill() {
          const slider = document.getElementById("ticket-price-range");
          if (slider) {
            // Check if the element exists
            const value = ((this.ticketPrice2 - 0) / (100 - 0)) * 100;
            slider.style.setProperty("--value", value + "%");
          }
        },
        updateTicketsSliderFill() {
          const ticketsSlider = document.getElementById(
            "number-of-tickets-range"
          );
          if (ticketsSlider) {
            // Check if the element exists
            const value = ((this.tickets2 - 0) / (1000 - 0)) * 100;
            ticketsSlider.style.setProperty("--value", value + "%");
          }
        },
      },
      watch: {
        ticketPrice(text) {
          this.ticketPrice2 = this.process(text);

          const ticketPriceRange =
            document.getElementById("ticket-price-range");
          if (ticketPriceRange) {
            this.updateSliderFill();
          }
        },
        ticketPrice2(text) {
          this.ticketPrice = this.process(text);

          const ticketPriceRange =
            document.getElementById("ticket-price-range");
          if (ticketPriceRange) {
            this.updateSliderFill();
          }
        },
        tickets(text) {
          this.tickets2 = this.process(text);

          const numberOfTicketsRange = document.getElementById(
            "number-of-tickets-range"
          );
          if (numberOfTicketsRange) {
            this.updateTicketsSliderFill();
          }
        },
        tickets2(text) {
          this.tickets = this.process(text);

          const numberOfTicketsRange = document.getElementById(
            "number-of-tickets-range"
          );
          if (numberOfTicketsRange) {
            this.updateTicketsSliderFill();
          }
        },
      },
      computed: {
        total: function () {
          return this.tickets * this.ticketPrice;
        },
        hasChanged: function () {
          return (
            this.ticketPrice !== this.initialTicketPrice ||
            this.ticketPrice2 !== this.initialTicketPrice2 ||
            this.tickets !== this.initialTickets ||
            this.tickets2 !== this.initialTickets2
          );
        },
      },
      mounted() {
        // Only call updateSliderFill if the element exists
        const ticketPriceRange = document.getElementById("ticket-price-range");
        if (ticketPriceRange) {
          this.updateSliderFill();
        }

        // Only call updateTicketsSliderFill if the element exists
        const numberOfTicketsRange = document.getElementById(
          "number-of-tickets-range"
        );
        if (numberOfTicketsRange) {
          this.updateTicketsSliderFill();
        }
      },
    });
  }
}
